import useLocalStorage from 'hooks/useLocalStorage';
import {
  warehouseDefaults,
  warehouseStorageName,
  WarehouseDeviceSettings,
} from 'types/warehouseSettings';
import { useGetStockLocationsClientV2Query } from 'store/slices/clientV2/stockLocations';
import useServerSideQuery from 'hooks/useServerSideQuery';
import {
  StockLocationSchema,
  StockLocationSchemaLite,
} from 'types/clientV2/stockLocations';
import { ALL, QueryFilterOperators } from 'types/api';
import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';

type UseIsFacilityUsingTeamsResult = {
  isUsingTeams: boolean;
  facility: StockLocationSchemaLite | undefined;
};

export const useIsFacilityUsingTeams = (): UseIsFacilityUsingTeamsResult => {
  const [settings, setSettings] = useLocalStorage(
    warehouseStorageName,
    warehouseDefaults
  );

  const { data: stockLocations } = useServerSideQuery<
    StockLocationSchema,
    StockLocationSchemaLite
  >(
    useGetStockLocationsClientV2Query,
    settings.facility
      ? {
          pageSize: 1,
          schema: [ALL],
          filters: [
            {
              field: 'id',
              operator: QueryFilterOperators['='],
              value: settings.facility,
            },
          ],
        }
      : skipToken
  );

  const facility = stockLocations?.data[0];

  useEffect(() => {
    if (
      facility?.useTeams !== undefined &&
      facility?.useTeams !== settings.useTeams
    ) {
      setSettings((prevSettings: WarehouseDeviceSettings) => ({
        ...prevSettings,
        useTeams: facility?.useTeams,
      }));
    }
  }, [facility?.useTeams, settings.useTeams, setSettings]);

  return {
    isUsingTeams: settings.useTeams || facility?.useTeams,
    facility,
  };
};
